import { useEffect, useState } from 'react';

function useFetch<P = Record<string, unknown>>(url: string): {
  isLoading: boolean,
  data: P | undefined,
  error?: Error,
} {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error>();
  const [data, setData] = useState<P>();

  useEffect(() => {
    if (!isLoading && !data && !error) {
      setIsLoading(true);

      window.fetch(`${process.env.REACT_APP_API_ROOT}${url}`)
        .then((response) => {
          if (!response.ok) {
            return response.json()
              .then((err) => setError(err));
          }

          return response.json().then(setData);
        })
        .catch(setError)
        .finally(() => setIsLoading(false));
    }
  }, [isLoading, data, url, error]);

  return {
    isLoading,
    data,
    error,
  };
}

export default useFetch;
